import { SwaggerApi } from "../models/api";

export const API: SwaggerApi = new SwaggerApi();
